import React from 'react';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/49f0a75b49ab3c1e54598eff14b87452.jpg"
          alt="Factory production floor - industrial manufacturing facility in China"
          title="Brand Guardian factory inspection services - manufacturing transparency"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/45" />
      </div>

      <div className="relative z-10 w-full px-6 lg:px-16 pt-32 pb-20">
        <div className="max-w-[720px]">
          <div className="flex items-center gap-3 mb-10">
            <span className="w-12 h-[1px] bg-[#D98C74]" />
            <span className="text-[#D98C74] text-[12px] font-semibold tracking-[0.25em] uppercase">
              your trusted brand presence on the ground in china
            </span>
          </div>

          <h1
            className="text-white text-[38px] lg:text-[54px] leading-[1.08] font-bold mb-7"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Your Eyes in China: Control What Happens When You're Not There
          </h1>

          <p className="text-white/75 text-[17px] lg:text-[19px] leading-[1.7] mb-10 max-w-[580px]">
            On-site factory oversight and brand protection for Western companies manufacturing in
            China.&nbsp;Ongoing on-site visits. Real-time transparency. Zero surprises.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-14">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-3 bg-[#D98C74] text-white px-8 py-4 rounded-md text-[15px] font-semibold hover:bg-[#c47a62] transition-all whitespace-nowrap cursor-pointer"
            >
              Book a Free Assessment
              <i className="ri-arrow-right-line text-lg" />
            </a>
            <a
              href="#process"
              className="inline-flex items-center justify-center gap-2 border border-white/30 text-white px-7 py-4 rounded-md text-[15px] font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              See How It Works
            </a>
          </div>

          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { icon: 'ri-shield-check-line', text: '100% Norwegian Owned' },
              { icon: 'ri-time-line', text: '48-Hour Visual Reports' },
              { icon: 'ri-map-pin-2-line', text: 'Based in Shanghai' },
            ].map((badge) => (
              <div
                key={badge.text}
                className="flex items-center gap-2 text-white/60 text-[13px]"
              >
                <i className={`${badge.icon} text-[#D98C74] text-base`} />
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-[#F5F0E6] to-transparent" />
    </section>
  );
}
